<template>
    <div v-if=!this.isLoading>
        <v-container>
            <v-form>
                <v-row class="px-8">
                    <h2 class="pb-5">
                        {{ parentObject.pageTitle }}
                    </h2>
                </v-row>
                <v-row class="mb-4">
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-btn color="warning" v-on:click="goBack">{{ $t('button.back') }}</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text" v-model="formData.pmassessmentrecorddesc" readonly
                        dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text" v-model="formData.pmassessmentrecordcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.periodfromdate')" type="date" ref="startdate"
                            :rules="[rules.required]" v-model="formData.startdate" dense 
                            class="v-input" readonly background-color='#ffeab2'
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.perioduntildate')"  type="date" ref="enddate"
                            :rules="[rules.required]" v-model="formData.enddate" dense 
                            class="v-input" readonly background-color='#ffeab2'
                        ></v-text-field>    
                    </v-col>
                </v-row>
                <v-row v-if="this.parentObject.groupname == null">
                    <h2 style="color: #3674cd">{{ this.parentObject.company }}</h2>
                </v-row>
                <v-row v-else>
                    <h2 style="color: #3674cd">{{ this.parentObject.company  +' > '+ this.parentObject.pageTitleValue }}</h2>
                </v-row>
                <v-row class="mx-n1" :key=this.rankCardKey>
                    <v-col 
                        v-for="rank in rankmapsetdetail" 
                        :key="rank.rank" 
                        cols="2" sm="2" md="2" lg="2" xl="2"
                        class="pa-1"
                    >
                        <v-card 
                            
                            :color="parentObject.groupname == null ? 'indigo darken-3' : 'green darken-2'"
                            dark 
                            class="text-left rounded-lg"
                            flat
                            height="100%"
                        >
                            <div class="px-2 pt-2 pb-1">  <!-- Reduced bottom padding -->
                                <div class="text-body-1 font-weight-bold mb-1">
                                    {{ rank.distribution }} %
                                </div>
                                <div class="text-caption mb-1">
                                    {{ getRankCount(rank.rank) }} {{$t('pmmoderation.employees')}}
                                </div>
                                <v-spacer></v-spacer>  <!-- Proper spacer usage -->
                                <div class="text-caption font-weight-bold">
                                    {{$t('Setuprankmapset.rank')}} {{ rank.rank }}
                                </div>  <!-- Bold rank -->
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                </v-row>
                <v-row>
                    <v-col col="12">
                        <app-table 
                        v-bind:parentObject="{
                            tabHeader: this.tabHeader,
                            detailItem: this.moderationdetaillist,
                            pmassessmentrecordid: this.formData.id,
                            ratingid: this.formData.ratingid,
                            pageTitle: this.parentObject.pageTitle +' '+this.parentObject.company +' '+this.parentObject.pageTitleValue+ ' Details',
                            isEdit: parentObject.isEdit,
                        }"
                        @updateRankCard="handleUpdateRankCard"
                    />
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>


<script>
import moment from 'moment';
import CRUDTable from "./CRUDTableDetail";

    export default {
        props: {
            parentObject: Object
        },

        components: {
            "app-table": CRUDTable,
        },

        data() {
            return {
                rules: {
                    required: value => !!value || this.$t('reportsparam.required'),
                },

                formData: {
                    id: this.parentObject.data.id,
                    pmassessmentrecordcode: this.parentObject.data.pmassessmentrecordcode,
                    pmassessmentrecorddesc: this.parentObject.data.pmassessmentrecorddesc,
                    startdate: this.parentObject.data.startdate,
                    enddate: this.parentObject.data.enddate,
                    ratingtype: this.parentObject.data.ratingtype,
                    ratingid: this.parentObject.data.ratingid,
                    userid: this.$store.getters.userId,
                },

                tabHeader: [
                    { text: this.$t('columns.actions'), value: 'action', width: '70px', sortable: false },
                    { text: this.$t('columns.staffid'), value: 'staffcode', width: '80px', sortable: false },
                    { text: this.$t('columns.staffname'), value: 'staffname', width: 'auto', sortable: false },
                    { text: this.$t('pmmoderation.periodfromdate'), value: 'startdate', width: '150px', sortable: false },
                    { text: this.$t('pmmoderation.perioduntildate'), value: 'enddate', width: '150px', sortable: false },
                    { text: this.$t('pmassementrecord.finalscore'), value: 'finalscore', width: 'auto', sortable: false },
                    { text: this.$t('Setuprankmapset.rank'), value: 'rank', width: 'auto', sortable: false },
                    { text: this.$t('pmassementrecord.finalrank'), value: 'finalrank', width: 'auto', sortable: false },
                    { text: this.$t('columns.company'), value: 'companycode', width: 'auto', sortable: false },
                    { text: this.$t('columns.branch'), value: 'branchcode', width: 'auto', sortable: false },
                    { text: this.$t('columns.department'), value: 'departmentcode', width: 'auto', sortable: false },
                    { text: this.$t('columns.section'), value: 'sectioncode', width: 'auto', sortable: false },
                    { text: this.$t('columns.unit'), value: 'unitcode', width: 'auto', sortable: false },
                    { text: this.$t('columns.grade'), value: 'gradecode', width: 'auto', sortable: false },
                    { text: this.$t('columns.position'), value: 'positioncode', width: 'auto', sortable: false },
                ],

                company: this.parentObject.company, 
                grouptype: this.parentObject.grouptype,
                groupname: this.parentObject.groupname,

                rankmapsetdetail: [],
                moderationdetaillist: [],
                errMsg: '',
                isErr: false,
                isEdit: this.parentObject.isEdit,
                isLoading: true,

                rankCardKey: 0, // 🔄 Used to force reactivity after the CRUD table update
                
            };
        },

        methods: {
            goBack() {
                if (window.history.length > 1) {
                    this.$router.go(-1); // Only go back if there's a history
                } else {
                    this.$router.push({ name: "performancemoderationrecordlist" }); // Go to home if no history
                }
            },

            async loadPmModerationDetailbyGroup() {//if no parent data for group type and group name, then full list
                this.isErr = false;
                this.errMsg = "";
                this.moderationdetaillist = []; // Reset the moderation detail
                try {
                    const res = await this.$store.dispatch('get', { url: `/moderationDetailByGroup/${this.formData.id}/${this.company}/${this.grouptype}/${this.groupname}` });
                    if (res.data.moderationDetail && res.data.moderationDetail.length > 0) {
                        this.moderationdetaillist = res.data.moderationDetail;
                        this.moderationdetaillist = res.data.moderationDetail.map(item => ({
                            ...item,
                            startdate: item.startdate ? moment(item.startdate).format('YYYY-MM-DD') : null,
                            enddate: item.enddate ? moment(item.enddate).format('YYYY-MM-DD') : null
                        }));
                    } else {
                        this.isErr = true;
                        console.error("Data not found");
                        this.errMsg = "Record not found.";
                    }
                } catch (err) {
                    console.error("Error loading record:", err);
                    this.isErr = true;
                    this.errMsg = err.message || "Network Error";
                }
            },

            async loadPmRankMapSetDetailById() {
                this.isErr = false;
                this.errMsg = "";
                this.rankmapsetdetail = []; // Reset the rank map detail
                try {
                    const res = await this.$store.dispatch('get', { url: `/rankmapsetdetails/${this.formData.ratingid}` });
                    if (res.data.rec && res.data.rec.length > 0) {
                        this.rankmapsetdetail = res.data.rec;
                    } else {
                        this.isErr = true;
                        console.error("Data not found");
                        this.errMsg = "Record not found.";
                    }
                } catch (err) {
                    console.error("Error loading record:", err);
                    this.isErr = true;
                    this.errMsg = err.message || "Network Error";
                }
            },

            getRankCount(rank) {
                if (!this.moderationdetaillist || !this.moderationdetaillist.length) return 0;
                return this.moderationdetaillist.filter(item => item.finalrank == rank).length;
            },
            
            getRankDistribution(rank) {
                if (!this.moderationdetaillist || !this.moderationdetaillist.length) return 0;
                const count = this.getRankCount(rank);
                return ((count / this.moderationdetaillist.length) * 100).toFixed(1);
            },

            async rankCardDataPreparation() {
                this.rankmapsetdetail = this.rankmapsetdetail.map(rank => ({
                    ...rank,
                    distribution: this.getRankDistribution(rank.rank)
                }));
                this.rankCardKey++;
            },

            async handleUpdateRankCard() {
                await this.rankCardDataPreparation();
            },
        },

        async mounted() {        
            try {                
                await this.loadPmModerationDetailbyGroup();
                await this.loadPmRankMapSetDetailById();
                await this.rankCardDataPreparation();
                this.isLoading=false;
            } catch (error) {
                console.error("❌ Error loading data:", error);
            }
        }
    };
</script>
<style scoped>
.v-card {
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.v-card > div {  /* Target the inner container */
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 8px 4px 8px;  /* Top, Sides, Bottom */
}

.v-card .text-body-1 {
    font-size: 0.8rem;
    line-height: 1.25;
    font-weight: bold;
}

.v-card .text-caption {
    font-size: 0.5rem;
    line-height: 1.25;
    font-weight: bold;
}

.v-card .v-spacer {
    flex-grow: 1;  /* Make spacer take available space */
    min-height: 8px;  /* Minimum space between sections */
}

/* More compact column spacing */
.v-col {
    padding: 4px !important;
}
</style>